export default "/images/843bffa54c1946d8ac93777ade3da803.avif";